import type { PartsPerStockRequestBody, PartsPerStockQueryKey } from './types';

export const getPartsPerStockMutationKey = (
  params: PartsPerStockRequestBody,
): PartsPerStockQueryKey => ['materials', 'parts_per_stock', params];
